import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multi-select-dropdown"
export default class extends Controller {
  static targets = ["button", "dropdown", "option"]

  connect() {
    this.selectedValues = new Set()
    
    // 外側クリックハンドラーを追加
    this.outsideClickHandler = this.handleOutsideClick.bind(this)
    document.addEventListener('click', this.outsideClickHandler)
  }

  // 外側クリックでドロップダウンを閉じる
  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      if (!this.dropdownTarget.classList.contains('hidden')) {
        this.dropdownTarget.classList.add('hidden')
      }
    }
  }

  // ドロップダウンの開閉
  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (!this.hasDropdownTarget) {
      console.error("❌ Dropdown target not found!")
      return
    }
    
    const dropdown = this.dropdownTarget
    const isHidden = dropdown.classList.contains('hidden')
    
    if (isHidden) {
      this.positionDropdown()
      dropdown.classList.remove('hidden')
    } else {
      dropdown.classList.add('hidden')
    }
  }

  // ドロップダウンの位置を動的に調整
  positionDropdown() {
    const dropdown = this.dropdownTarget
    const button = this.buttonTarget
    const rect = button.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const dropdownHeight = 256 // max-h-64 = 16rem = 256px
    
    // ボタンの下にドロップダウンを表示するのに十分なスペースがあるかチェック
    const spaceBelow = viewportHeight - rect.bottom
    const spaceAbove = rect.top
    
    
    // スペースが足りない場合は上向きに表示
    if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
      dropdown.classList.remove('mt-1')
      dropdown.classList.add('mb-1', 'bottom-full')
      
      // シャドウも上向きに調整
      dropdown.style.boxShadow = '0 -10px 15px -3px rgba(0, 0, 0, 0.1), 0 -4px 6px -2px rgba(0, 0, 0, 0.05)'
    } else {
      dropdown.classList.remove('mb-1', 'bottom-full')
      dropdown.classList.add('mt-1')
      
      // 通常のシャドウに戻す
      dropdown.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
    }
  }

  // オプションの選択
  selectOption(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const option = event.currentTarget
    const value = option.dataset.value
    
    if (this.selectedValues.has(value)) {
      this.selectedValues.delete(value)
      option.style.backgroundColor = ''
      option.style.color = ''
    } else {
      this.selectedValues.add(value)
      option.style.backgroundColor = '#2563eb'
      option.style.color = 'white'
    }
    
    // ボタンテキストの更新
    this.updateButtonText()
    
    // 隠しinputの更新
    this.updateHiddenInputs()
    
    // 検索件数の更新をトリガー
    this.triggerSearchUpdate()
    
  }

  // 隠しinputの更新
  updateHiddenInputs() {
    // 既存の隠しinputを削除
    const existingInputs = this.element.querySelectorAll('input[name="point[]"]')
    existingInputs.forEach(input => input.remove())
    
    // 新しい隠しinputを作成
    this.selectedValues.forEach(value => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'point[]'
      input.value = value
      this.element.appendChild(input)
    })
    
  }

  // 検索件数の更新をトリガー
  triggerSearchUpdate() {
    
    // まず親のフォーム要素を探す
    const formElement = this.element.closest('form')
    
    if (formElement) {
      // フォーム内のsearch-formコントローラーを探す
      const searchFormElement = formElement.closest('[data-controller*="search-form"]')
      
      if (searchFormElement) {
        // Stimulusコントローラーを取得
        const application = window.Stimulus || this.application
        if (application) {
          const searchController = application.getControllerForElementAndIdentifier(searchFormElement, 'search-form')
          
          if (searchController && searchController.updateCountImmediate) {
            searchController.updateCountImmediate()
            return
          }
        }
      }
    }
    
    // 代替方法：カスタムイベントを発火
    const customEvent = new CustomEvent('multi-select-changed', {
      detail: { selectedValues: Array.from(this.selectedValues) },
      bubbles: true
    })
    this.element.dispatchEvent(customEvent)
  }

  // ボタンテキストの更新
  updateButtonText() {
    const count = this.selectedValues.size
    const buttonText = this.buttonTarget.querySelector('.button-text') || this.buttonTarget
    
    if (count === 0) {
      buttonText.textContent = 'こだわり条件を選択 ▼'
    } else {
      buttonText.textContent = `${count}個の条件を選択中 ▼`
    }
  }

  // 外側クリックでドロップダウンを閉じる
  disconnect() {
    document.removeEventListener('click', this.outsideClickHandler)
  }
}